<script lang="ts" setup>
import HeaderLogo from '@/components/app/nav/HeaderLogo.vue'
import mfcIcon from '@images/icons/mfc-grey.svg'
import type { NavItems } from '@/interfaces/nav'
import { useAuthStore } from '@/stores/auth'

defineProps<{
  navItems: NavItems
}>()

const authStore = useAuthStore()
</script>

<template>
  <div>
    <VListItem
      :prepend-avatar="mfcIcon"
      title="MyHQ"
    >
      <template #prepend>
        <HeaderLogo class="my-2" />
      </template>
    </VListItem>

    <VDivider />
    <VList
      density="compact"
      open-strategy="single"
      nav
    >
      <template v-if="authStore.authenticated">
        <VListItem
          v-for="navItem in navItems"
          :key="navItem.title"
          class="nav-link"
        >
          <template v-if="navItem.subNav">
            <VListGroup>
              <template #activator="{ props }">
                <VListItem
                  v-bind="props"
                  :prepend-icon="navItem.icon"
                  :title="navItem.title"
                />
              </template>
              <VListItem
                v-for="subNavItem in navItem.subNav"
                :key="subNavItem.title"
                :prepend-icon="subNavItem.icon"
                :to="subNavItem.to ?? ''"
                :href="subNavItem.href ?? ''"
                :target="subNavItem.target ?? '_self'"
                :title="subNavItem.title"
              />
            </VListGroup>
          </template>
          <template v-else>
            <VListItem
              color="secondary"
              :prepend-icon="navItem.icon"
              :to="navItem.to"
              :href="navItem.href ?? ''"
              :target="navItem.target ?? '_self'"
              :title="navItem.title"
            />
          </template>
        </VListItem>
      </template>
    </VList>
  </div>
</template>
